import React from 'react'
import "./RiskDisclosures.css";
import { Container, Col, Row } from "react-bootstrap";

function RiskDisclosures() {

  return (
    <>
      <div className="riskdisclosures_page">
        <section className="our-story-block disclaimer">
          <Container>
            <Row>
              <Col md={{ span: 12, offset: 0 }}>
                <div className="our-story-inner arrow-main">
                  <h2>Risk Disclosures</h2>
                  <div className="riskdisclosures_derivatives pt-4 pb-2">
                    <h4 className="pl-3 riskPl"><strong className='riskhead'>RISK DISCLOSURES ON DERIVATIVES</strong></h4>
                    <ul className='riskUl'>
                      <li>9 out of 10 individual traders in equity Futures and Options Segment, incurred net losses.</li>
                      <li>On an average, loss makers registered net trading loss close to ₹ 50,000</li>
                      <li>Over and above the net trading losses incurred, loss makers expended an additional 28%
                        of net trading losses as transaction costs</li>
                      <li>Those making net trading profits, incurred between 15% to 50% of such profits as
                        transaction cost.</li>
                    </ul>
                  </div>
                  <p className="riskdisclosuresderivatives_source"><strong>Source:</strong></p>
                  <p className=''><a href="https://www.sebi.gov.in/reports-and-statistics/research/jan-2023/study-analysis-of-profit-and-loss-of-individual-traders-dealing-in-equity-fando-segment_67525.html">SEBI study dated January 25, 2023 on “Analysis of Profit and Loss of Individual Traders dealing in
                    equity Futures and Options (F&O) Segment”, wherein Aggregate Level findings are based on annual
                    Profit/Loss incurred by individual traders in equity F&O during FY 2021-22</a></p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
}
export default RiskDisclosures;
